import "./App.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "./pages/home/Home";

import {
  DiscussLoader,
  DashboardNavbar,
  Footer,
  NAVBar,
  Navbar,
  NewAd,
  EcoBookSkeletonLoader,
  ChatNav,
} from "./components";
import CampaignOverview from "./pages/adManager/NewCampaign/campaignOverview";

import { lazy, Suspense, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import Trips from "./pages/trips/Trips";
import Host from "./pages/host/Host";
import { useDispatch, useSelector } from "react-redux";
import VerificationForm from "./pages/IdVerification/VerificationForm";
import { RootState } from "./redux/store";
import { showToast } from "./utils/showToast";
// import ForgotPassword from "./pages/forgotPassword/forgotPassword";
// import { WebSocket } from "ws";

// function delayForDemo(promise: any) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, 5000);
//   }).then(() => promise);
// }
const ForgotPassword = lazy(
  () => import("./pages/forgotPassword/forgotPassword")
);
const About = lazy(() => import("./pages/about/About"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));
const UserProfile = lazy(() => import("./pages/dashboard/Profile"));
const Settings = lazy(() => import("./pages/dashboard/Settings"));
const Payments = lazy(() => import("./pages/dashboard/Payments"));
const Reviews = lazy(() => import("./pages/reviews/Reviews"));
const WalletConnect = lazy(() => import("./pages/walletConnect/WalletConnect"));
const AddVehicle = lazy(() => import("./pages/addVehicle/AddVehicle"));
const RentalSummary = lazy(() => import("./pages/rentalSummary/RentalSummary"));
const LocateVehicle = lazy(() => import("./pages/locateVehicle/LocateVehicle"));
const ReturnVehicle = lazy(() => import("./pages/returnVehicle/ReturnVehicle"));
const Vehicles = lazy(() => import("./pages/vehicles/Vehicles"));
const RentalForm = lazy(() => import("./pages/rentalFrom/RentalForm"));
const EditProfile = lazy(() => import("./pages/ecoProfile/EditProfile"));
const News = lazy(() => import("./pages/news/News"));
const NewsView = lazy(() => import("./pages/news/NewsView"));
const Team = lazy(() => import("./pages/team/Team"));
const Contact = lazy(() => import("./pages/contact/Contact"));
const AdHome = lazy(() => import("./pages/adManager/home/AdHome"));
const AdDashboard = lazy(() => import("./pages/adManager/dashboard/Dashboard"));
const NotFound = lazy(() => import("./pages/404/NotFound"));
const Terms = lazy(() => import("./pages/policies/Terms"));
const Privacy = lazy(() => import("./pages/policies/Privacy"));
const AdditionalPolicies = lazy(
  () => import("./pages/policies/AdditionalPolicies")
);
const CommunityGuidelines = lazy(
  () => import("./pages/policies/CommunityGuidelines")
);
const DriverEligibility = lazy(
  () => import("./pages/policies/DriverEligibility")
);
const SecurityDeposits = lazy(
  () => import("./pages/policies/SecurityDeposits")
);
const VehicleCategory = lazy(() => import("./pages/policies/VehicleCategory"));
const Cancellation = lazy(() => import("./pages/policies/Cancellation"));

const CommunityHome = lazy(
  () => import("./pages/community/Home/communityHome")
);
const EcoBook = lazy(
  () => import("./pages/community/Ecobook/ecobookHome/ecobook")
);
const Discuss = lazy(
  () => import("./pages/community/Ecobook/EcoCommunity/Discuss/Discuss")
);
const Profile = lazy(() => import("./pages/ecoProfile/Profile"));
const Chat = lazy(() => import("./pages/Chat/chat"));
const ChatBox = lazy(() => import("./pages/Chat/chatBox"));

const add = "+ad4e_nj";

function MyFallbackComponent({ error, resetErrorBoundary }: FallbackProps) {
  console.log(error);
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Something went wrong.</h1>
      {/* <p className="mb-4">{error.message}</p> */}
      <button
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-midGreen text-white rounded hover:bg-darkGreen"
      >
        Try Again
      </button>
    </div>
  );
}

function SuspenseComponent() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800">
      <img
        src="https://res.cloudinary.com/dicsazvfz/image/upload/v1695721086/logo_2_jqzkji.png"
        alt=""
        className=" flex h-20 w-20 justify-center items-center"
      />
    </div>
  );
}

function App() {
  const dispatch = useDispatch();

  // const { data, loading, error } = useSubscription(CAR_CONDITIONAL_PRICE, {
  //   onComplete() {
  //     console.log("Car conditional price subscription done");
  //   },
  //   onData(data) {
  //     // console.log("Car conditional price subscription", data);
  //     // console.log("onData", data.data?.data?.carConditionalPrice[0]);
  //     data.data?.data?.carConditionalPrice.map((car: any) =>
  //       dispatch(updateDisplayVehicles(car))
  //     );
  //   },
  //   onError(error) {
  //     console.log("Car conditional price subscription", error);
  //   },
  // });

  const Layout = () => {
    const path = useLocation().pathname;

    const navigate = useNavigate();

    const userDetails = useSelector(
      (state: RootState) => state?.user?.userDetails
    );

    useEffect(() => {
      window.localStorage.setItem("currPath", path);
      window.scrollTo(0, 0);

      if (
        path !== "/" &&
        path !== "/about" &&
        path !== "/team" &&
        path !== "/news" &&
        path !== "/contact" &&
        path !== "/policies/terms-of-service" &&
        path !== "/policies/privacy-policy" &&
        path !== "/policies/cancellation-policy" &&
        path !== "/policies/additional-policies" &&
        path !== "/policies/vehicle-categorization" &&
        path !== "/policies/driver-eligibility" &&
        path !== "/policies/community-guidelines" &&
        path !== "/policies/security-deposits" &&
        path !== "/auth" &&
        path !== "/vehicles" &&
        !userDetails
      ) {
        // console.log("Session has expired");
        showToast("Login to continue", "error");
        // redirect("/auth");
        window.localStorage.setItem("authFailLocation", path);

        navigate("/auth");
      }
    }, [path]);
    return (
      <div>
        <Navbar />
        <Outlet />
        {/* <div className="" id="orokii-pay-widget-container"></div> */}
        <Footer />
      </div>
    );
  };

  const AuthLayout = () => {
    return (
      <div>
        <Outlet />
      </div>
    );
  };

  const DashboardLayout = () => {
    return (
      // <div className="h-screen overflow-hidden">
      //   <div className="flex flex-row  justify-between h-full w-full bg-[#fbfafa] overflow-x-hidden">
      //     <DashboardSidebar />
      //     <div className="  flex flex-1 flex-col bg-[#fbfafa] overflow-y-scroll ">
      //       <div className="sticky top-0 z-[9999]">
      //         <DashboardNavbar />
      //       </div>
      //       <Outlet />
      //     </div>
      //   </div>
      // </div>
      <div className=" bg-white">
        <Navbar />
        <DashboardNavbar />
        <Outlet />
      </div>
    );
  };

  const EcobookChatLayout = () => {
    return (
      <div className="lg:bg-inherit bg-white lg:mt-[73px] mt-[50px] w-full">
        <NAVBar />
        <div className="lg:relative flex flex-col lg:h-[90vh] h-[calc(100%-50px)] lg:mx-auto w-full items-center">
          <ChatNav />
          <div className="lg:grid lg:place-items-center h-full w-full">
            <div className="flex bg-[#ffffff80] lg:h-[calc(90vh-73px)] max-h-[78vh] w-full lg:w-[70%] lg:shadow">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const EcobookLayout = () => {
    return (
      <div>
        <NAVBar />
        <div className="mt-[65px]">
          <Outlet />
        </div>
      </div>
    );
  };

  const AdManagerLayout = () => {
    return (
      <div>
        <Outlet />
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/about",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <About />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/news",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <News />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/news/:id",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <NewsView />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/team",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Team />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/contact",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Contact />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        // {
        //   path: "/dashboard",
        //   element: <Dashboard />,
        // },
        {
          path: "/vehicles",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Vehicles />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/auth",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <WalletConnect />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/vehicles/add",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <AddVehicle />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/vehicles/rental/:id",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <RentalForm />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        // {
        //   path: "/vehicles/rental/date/:id",
        //   element: (
        //     <ErrorBoundary FallbackComponent={MyFallbackComponent}>
        //       <Suspense fallback={<SuspenseComponent />}>
        //         <RentalDate />
        //       </Suspense>
        //     </ErrorBoundary>
        //   ),
        // },
        {
          path: "/vehicles/rental/summary/:id",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <RentalSummary />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/vehicles/rental/locate/:id",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <LocateVehicle />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/vehicles/rental/return/:id",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <ReturnVehicle />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/terms-of-service",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Terms />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/privacy-policy",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Privacy />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/cancellation-policy",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Cancellation />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/additional-policies",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <AdditionalPolicies />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/vehicle-categorization",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <VehicleCategory />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/driver-eligibility",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <DriverEligibility />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/community-guidelines",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <CommunityGuidelines />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/policies/security-deposits",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <SecurityDeposits />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "*",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <NotFound />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "/trips",
          element: <Trips />,
        },
        {
          path: "/host",
          element: <Host />,
        },
        {
          path: "/verification",
          element: <VerificationForm />,
        },
      ],
    },
    {
      path: "/forgetPassword",
      element: (
        <ErrorBoundary FallbackComponent={MyFallbackComponent}>
          <Suspense fallback={<SuspenseComponent />}>
            <ForgotPassword />
          </Suspense>
        </ErrorBoundary>
      ),
    },
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Dashboard />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "profile",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <UserProfile />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "settings",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Settings />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "payments",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Payments />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "reviews",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Reviews />
              </Suspense>
            </ErrorBoundary>
          ),
        },
      ],
    },
    {
      path: "/chat/e",
      element: <EcobookChatLayout />,
      children: [
        {
          path: "",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Chat />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: ":id",
          element: (
            <>
              <Suspense fallback={<SuspenseComponent />}>
                {/* <Chat /> */}
                <ChatBox />
              </Suspense>
            </>
          ),
        },
      ],
    },
    {
      path: "/ecobook",
      element: <EcobookLayout />,
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<DiscussLoader />}>
              <CommunityHome />
            </Suspense>
          ),
        },
        // {
        //   path: "marketplace",
        //   element: (
        // <ErrorBoundary FallbackComponent={MyFallbackComponent}>
        // <Suspense fallback={<SuspenseComponent />}>
        //       <MarketPlace />
        //     </Suspense>
        // </ErrorBoundary>//
        //   ),
        // },
        {
          path: "my-communities",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<EcoBookSkeletonLoader />}>
                <EcoBook />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "community/:name/:id?",
          element: (
            <Suspense fallback={<DiscussLoader />}>
              <Discuss />
            </Suspense>
          ),
        },
        {
          path: `profile/:id${add}`,
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <Profile />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: `profile/:id${add}/edit-profile`,
          element: (
            <Suspense fallback={<SuspenseComponent />}>
              <EditProfile />
            </Suspense>
          ),
        },
        // {
        //   path: "ecomotochat",
        //   element: (
        //     <ErrorBoundary FallbackComponent={MyFallbackComponent}>
        //       <Suspense fallback={<SuspenseComponent />}>
        //         <EcomotoChat />
        //       </Suspense>
        //     </ErrorBoundary>
        //   ),
        // },
        // {
        //   path: "chat",
        //   element: (
        //     <ErrorBoundary FallbackComponent={MyFallbackComponent}>
        //       <Suspense fallback={<SuspenseComponent />}>
        //         <Chat />
        //       </Suspense>
        //     </ErrorBoundary>
        //   ),
        // },
      ],
    },
    {
      path: "/ad-manager",
      element: <AdManagerLayout />,
      children: [
        {
          path: "",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <AdHome />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "dashboard",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <AdDashboard />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "dashboard/create-new-campaign",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <NewAd />
              </Suspense>
            </ErrorBoundary>
          ),
        },
        {
          path: "dashboard/overview",
          element: (
            <ErrorBoundary FallbackComponent={MyFallbackComponent}>
              <Suspense fallback={<SuspenseComponent />}>
                <CampaignOverview />
              </Suspense>
            </ErrorBoundary>
          ),
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
